'use client';

import { ethSignAesDecrypt } from '@ethsign/utils-web';

import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { DecryptContractModal, Loading } from '@/components';
import { useRouter } from '@/hooks';

import { ContractType } from '@/types';
import { reportGAEvent } from '@/utils';

import { useViewModel } from '@/utils/bizify';

import { PageCtrl } from './PageCtrl';
import { Detail } from './components/Detail';
import { Header } from './components/Header';

export default function Page() {
  const { id } = useParams();
  const router = useRouter();
  const vm = useViewModel(PageCtrl);
  const vmData = vm.$useSnapshot();
  const { contract, file, xfdfStrings, subContractXfdfStrings } = vmData;

  const isVisualContractView = contract?.contractType === ContractType.visual_contract;
  const isShowDownload = !isVisualContractView && contract?.clientStatus === 'completed';
  useEffect(() => {
    vm.initInfo({ id, isVisualContractView });
  }, []);

  useEffect(() => {
    if (contract) {
      reportGAEvent('pc_contract_contractShareView', {
        contractId: id,
        contractType: contract.contractType
      });
    }
  }, [contract, id]);

  return (
    <div className="w-full h-full ">
      <Header
        id={contract?.id}
        isShowDownload={isShowDownload}
        onDownload={() => {
          vm.downloadFile(contract.id);
        }}
      ></Header>
      {vmData.loading && <Loading />}
      <Detail
        onDownload={(id) => {
          vm.downloadFile(id);
        }}
        subContractXfdfStrings={subContractXfdfStrings}
        isVisualContractView={isVisualContractView}
        onUserChange={(contractId: string) => {
          contractId && vm.getContract(contractId);
        }}
        onLoaded={() => {
          vm.setLoading(false);
        }}
        contract={contract}
        file={file}
        xfdfStrings={xfdfStrings}
        viewMore={async () => {
          await vm.getRecipients(id);
        }}
        hasMore={vmData.recipientsHasMore}
      />
      <DecryptContractModal
        onClose={() => {
          vm.setModalOpen(false);
          !vmData.file && router.push('/dashboard');
        }}
        isShowAutoOpenPasswordManager={false}
        open={vmData.modalOpen}
        onOpenChange={(open) => {
          vm.setModalOpen(open);
        }}
        onConfirm={async (value) => {
          try {
            const file = await ethSignAesDecrypt(vmData.encryptFile, value);
            vm.passwordConfirm(JSON.parse(file), value);
            return true;
          } catch (error) {
            return false;
          }
        }}
      ></DecryptContractModal>
    </div>
  );
}
